import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import moment from 'moment';

import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import {
  collection,
  getDocs,
  query,
  where,
  addDoc, updateDoc,
  doc,
  orderBy,
  onSnapshot,
  deleteDoc,
  serverTimestamp
} from "firebase/firestore";
import './ForumDetails.css';

import { Footer } from '../../components/footer/footer';
import Googleadshorizontal from '../../components/google-AdSense/Googleadshorizontal';
import Navbarr from '../../components/header/Navbarr';
import ScrollButton from '../../components/scrollbutton/ScrollButton';
import Subheader from '../../components/subheader/Subheader';
import { ModalCustom } from '../../components/modalcustom/modalcustom';
import profileimg from "../../assets/large profileicon.svg";
import { imgpath, imgpathapp } from '../../Config/config';

import { db } from '../../Config/firebase';
import { Errormsg } from '../../components/tostifymsg/Errrormsg';
import { Link, useParams } from 'react-router-dom';

function ForumDetails() {
  const { id } = useParams();
  const loginuserinfo = useSelector((state) => state.loginuserinfo);

  const userprofileimage = Cookies.get("userprofileimage");
  const email = Cookies.get("email");
  const userId = Cookies.get("id");
  const username = Cookies.get("username");
  const firebaseUseruid = Cookies.get('firebaseuid');

  const [post, setPost] = useState(null);
  const [newComment, setNewComment] = useState("");
  const [comments, setComments] = useState([]);
  
  useEffect(() => {
    let qPost = query(
      collection(db, "Posts"),
      where("id", "==", id),
      orderBy("createdAt", "desc")
    );

    const unsubscribePost = onSnapshot(qPost, (snapshot) => {
      const posts = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setPost(posts[0] || null);
    });

    const qComments = query(
      collection(db, "CommentsInPosts"),
      where("postId", "==", id),
      orderBy("createdAt", "asc")
    );

    const unsubscribeComments = onSnapshot(qComments, (snapshot) => {
      const comments = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setComments(comments);
    });

    return () => {
      unsubscribePost()
      unsubscribeComments()
    };
  }, [id]);

  const handlerDeleteComment = async (commentId) => {
    if (!commentId) return;

    try {
      await deleteDoc(doc(db, "CommentsInPosts", commentId));
    } catch (error) {
      console.error("Error deleting comment: ", error);
      Errormsg("Failed to delete comment. Please try again.");
    }
  }

  const handleCommentSubmit = async () => {
    if (!newComment.trim()) {
      Errormsg("Comment cannot be empty.");
      return;
    }
    
    if (!loginuserinfo) {
      Errormsg("You must be logged in to post a comment.");
      return;
    }

    try {
      const dateNowServer = serverTimestamp();
      let imageProfileUrl = `${imgpathapp}` + (
        typeof userprofileimage === 'undefined' || 
        userprofileimage === 'undefined' || 
        userprofileimage === null 
        ? `${profileimg}` : 
          `${userprofileimage}`);
          
      const commentData = {
        comment: newComment,
        commentsCount: 0,
        createdAt: dateNowServer,
        description: post?.description || '',
        email: email || '',
        idOwnerPost: post?.id || '',
        idParentComment: '',
        idUser: firebaseUseruid || null,
        postId: post?.id || '',
        title: '',
        updatedAt: dateNowServer,
        urlProfile: imageProfileUrl || null,
        username: username || 'Anonymous',
      };
      
      await addDoc(collection(db, "CommentsInPosts"), commentData);
      setNewComment("");
    } catch (error) {
      console.error("Error submitting comment: ", error);
      Errormsg("Failed to submit comment. Please try again.");
    }
  }

  return (
    <div>
      <Navbarr/>

      <div className="after-nav-dsubheader containers con_div">
        <Googleadshorizontal props="mt-2 mb-2 text-center"/>
        <Subheader />      
				
				{ post && (
          <div className='h-100 min-vh-100'>
            <h1 className='text-center mt-5 text-white fw-bold'>{ post?.title || ''}</h1>

            <div className='d-flex justify-content-center align-items-center mt-3'>
              <div className='container-max'>
                <div className='forum-post forum-post-primary p-4 mt-4 mb-2 rounded-4 text-white'>
                  <p className='m-0'>{ post.description }</p>

                  <div className='d-flex justify-content-between align-items-center'>
                    <p className='m-0 text-gray-custom'>
                      <small>{moment.tz(post?.createdAt?.toDate(), "UTC").fromNow()}</small>
                    </p>

                    <div className='text-gray-custom'>
                      <span className='icon icon-custom-posts ms-0 me-0'>
                        <small><i class="fa fa-comments"></i> <span className='text-white'>{post.commentsCount || 0}</span></small>
                      </span>
                    </div>
                  </div>
                </div>
              
                { comments.length === 0 && (
                  <div className='container forum-post p-4 mb-4 mt-4 rounded-4 text-white'>
                      <p className='text-center'>No comments yet.</p>
                  </div>
                )}


                { comments.length > 0 && comments.map((comment) => (
                    <div key={comment.id} className='d-flex'>
                      <div className='content-divide-comment p-4'>
                      </div>

                      <div className='w-100 forum-post forum-post-secoundary p-4 mt-4 mb-5 rounded-4 text-white'>
                        <div className='d-flex justify-content-between align-items-start'>
                          <p className='m-0'>{comment.username}</p>
                          <p className='m-0 text-gray-custom'>
                            <small>{moment.tz(comment?.createdAt?.toDate(), "UTC").fromNow()}</small>
                          </p>
                        </div>
                        <div className='d-flex justify-content-between align-items-center'>
                          <p className='m-0 text-gray-custom'>{comment.comment}</p>
                          { firebaseUseruid && firebaseUseruid.includes(comment.idUser) && (
                              <button className='btn btn-sm text-decoration-none text-white border mt-2' onClick={() => handlerDeleteComment(comment.id)}><small>Delete</small></button>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  ))
                }

                <div className='content-write-comment p-4 mb-5 rounded-4 text-white'>
                  <textarea className='form-control border-0 text-white write-comment-input mb-3' rows='3' placeholder='Write a comment...' value={newComment} onChange={(e) => setNewComment(e.target.value)}></textarea>
                  <button className='btn btn-success w-100 mt-2' onClick={handleCommentSubmit}>Submit</button>
                </div>
              </div>
            </div>
          </div>
        ) }
      </div>

      

      <Footer />
      <ScrollButton />
    </div>
  );
}

export default ForumDetails;